import { render, staticRenderFns } from "./HotelStats.vue?vue&type=template&id=412af132&"
import script from "./HotelStats.vue?vue&type=script&lang=js&"
export * from "./HotelStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports